module.exports = __webpack_public_path__ + "img/compras-sec.533d4cc3.png";